<template
    ><div class="pa-5 compact-form" v-if="add_new">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Company name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.store.company_name"
                    @input="updateStoreField($event, 'company_name')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Chain name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.store.chain_name"
                    @input="updateStoreField($event, 'chain_name')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Identification code" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.store.identification_code"
                    @input="updateStoreField($event, 'identification_code')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Company address" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeShop.store.address"
                    @input="updateStoreField($event, 'address')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col cols="6">
                <v-autocomplete
                    :value="activeShop.store.country"
                    @change="updateStoreField($event, 'country')"
                    :items="countries"
                    :loading="isLoading"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    hide-no-data
                    hide-selected
                    :item-text="
                        item =>
                            (item.name_et ? item.name_et : null) +
                            (item.name_en ? item.name_en : null) +
                            ' (' +
                            item.code +
                            ')'
                    "
                    item-value="code"
                    outlined
                    :placeholder="t('Start typing to Search')"
                >
                    <template slot="selection" slot-scope="{ item, selected }">
                        {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                    </template>
                    <template slot="item" slot-scope="{ item, tile }">
                        <country-flag :country="item.code" size="small" class="mr-1" />
                        {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col :cols="1">
                <country-flag
                    v-if="activeShop.store.country"
                    :country="activeShop.store.country"
                    class="mt-0 ml-1"
                    size="normal"
                />
            </v-col>
        </v-row>
    </div>
    <div class="pa-5 compact-form" v-else-if="this.stores && !add_new">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Chain name" | t }}</v-col>
            <v-col cols="6">
                <v-select
                    v-model="select"
                    :items="stores"
                    menu-props="auto"
                    hide-details
                    label="Select chain"
                    single-line
                    outlined
                    dense
                    @change="updateStoreField($event, 'company_name')"
                ></v-select
            ></v-col>
        </v-row>
        <v-divider class="my-2" />
        <div>
            <v-btn dark color="bal-red" class="px-2 ml-2 mt-2" @click.stop="add_new = !add_new" style="min-width: 0;">
                <v-icon>add</v-icon><span>{{ "Add new store" | t }}</span>
            </v-btn>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Store from "@/store";
import CountryFlag from "vue-country-flag";

export default {
    name: "store-info-edit-tab",
    data() {
        return {
            select: null,
            add_new: false,
            isLoading: false
        };
    },
    components: {
        CountryFlag
    },
    computed: {
        ...mapState("ShopsAdminStore", ["activeShop", "stores"]),
        ...mapState(["countries"])
    },
    async mounted() {
        await this.getStores();
        this.select = this.activeShop.store.company_name ? this.activeShop.store.company_name : null;
    },
    methods: {
        ...mapActions("ShopsAdminStore", ["getStores"]),
        updateStoreField(value, field) {
            Store.commit("ShopsAdminStore/updateActiveShopStoreProperty", { prop: field, value: value });
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
</style>
